import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type FeatureFlag = {
  inplappwebview: boolean;
};

type FeatureFlagState = FeatureFlag & {
  hydrated: boolean;
};

type FeatureFlagAction = {
  setInPLAppWebViewFlag: (flag: boolean) => void;
  setFeatureFlagHydrated: () => void;
};

const defaultState: FeatureFlagState = {
  inplappwebview: false,
  hydrated: false,
};

export const useFeatureFlagStore = create<FeatureFlagState & FeatureFlagAction>()(
  persist(
    devtools(
      immer((set) => ({
        ...defaultState,
        setInPLAppWebViewFlag(flag) {
          set((state) => {
            state.inplappwebview = flag;
          });
        },
        setFeatureFlagHydrated() {
          set((state) => {
            state.hydrated = true;
          });
        },
      })),
      {
        name: 'Feature Flag Store',
        enabled: true,
      },
    ),
    {
      name: 'feature-flag-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ inplappwebview: state.inplappwebview }),
      onRehydrateStorage: () => (state) => {
        // mark store as hydrated after localStorage finishes loading
        state?.setFeatureFlagHydrated();
      },
    },
  ),
);
